import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Plus, Trash2, Truck } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const Carriers = () => {
  const [carriers, setCarriers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ nome: '' });

  useEffect(() => {
    fetchCarriers();
  }, []);

  const fetchCarriers = async () => {
    try {
      const response = await axios.get(`${API}/carriers`);
      setCarriers(response.data);
    } catch (error) {
      toast.error('Erro ao carregar transportadoras');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/carriers`, formData);
      toast.success('Transportadora criada com sucesso!');
      fetchCarriers();
      resetForm();
    } catch (error) {
      toast.error('Erro ao criar transportadora');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja deletar esta transportadora?')) {
      try {
        await axios.delete(`${API}/carriers/${id}`);
        toast.success('Transportadora deletada com sucesso!');
        fetchCarriers();
      } catch (error) {
        toast.error('Erro ao deletar transportadora');
      }
    }
  };

  const resetForm = () => {
    setShowForm(false);
    setFormData({ nome: '' });
  };

  if (loading) {
    return <div className="flex items-center justify-center h-full"><div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin" /></div>;
  }

  return (
    <div className="space-y-6" data-testid="carriers-page">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-3xl font-heading font-bold text-foreground">Transportadoras</h2>
          <p className="text-muted-foreground mt-1">Gerencie suas transportadoras</p>
        </div>
        <button onClick={() => setShowForm(!showForm)} data-testid="add-carrier-btn" className="btn-primary flex items-center gap-2">
          <Plus className="w-5 h-5" />
          Nova Transportadora
        </button>
      </div>

      {showForm && (
        <div className="bg-card border border-border rounded-lg p-6">
          <h3 className="text-xl font-heading font-semibold mb-4">Nova Transportadora</h3>
          <form onSubmit={handleSubmit} className="flex gap-3">
            <input
              type="text"
              value={formData.nome}
              onChange={(e) => setFormData({ nome: e.target.value })}
              placeholder="Nome da transportadora"
              className="input-field flex-1"
            />
            <button type="submit" className="btn-primary">Adicionar</button>
            <button type="button" onClick={resetForm} className="btn-secondary">Cancelar</button>
          </form>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {carriers.map((carrier) => (
          <div key={carrier.id} className="bg-card border border-border rounded-lg p-6 flex items-center justify-between hover:shadow-md transition-all">
            <div className="flex items-center gap-3">
              <div className="p-3 rounded-lg bg-orange-100 dark:bg-orange-900/20">
                <Truck className="w-6 h-6 text-primary" />
              </div>
              <h4 className="font-heading font-semibold text-lg">{carrier.nome}</h4>
            </div>
            <button
              onClick={() => handleDelete(carrier.id)}
              className="text-red-600 hover:text-red-800 p-2 rounded-lg hover:bg-red-100 dark:hover:bg-red-900/20 transition-colors"
              title="Deletar"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>

      {carriers.length === 0 && !showForm && (
        <div className="text-center py-12 text-muted-foreground">
          <Truck className="w-16 h-16 mx-auto mb-4 opacity-50" />
          <p>Nenhuma transportadora cadastrada</p>
        </div>
      )}
    </div>
  );
};
